import { Fragment } from "react";
import { signal } from "@preact/signals-react";

import { FormattedMessage as FM } from "react-intl";
import { useStore } from "storev2/formStore";
import { layoutStaffSupply } from "../../models/LayoutStaffSupply";
import SignatureCell from "componentsv2/experimental/SignatureCell";
import proxy from "api/proxy";
import { useTable } from "storev2/tableStore";
import { Alert } from "components/Alerts/Alert";

const DEFAULT_STYLE = "max-w-[820px] mx-auto mt-[66px] mb-[300px]";
const alertMsg = signal({
  show: false,
  text: null,
  icon: "check",
  color: "bg-green-200",
  position: "relative",
  className: "mt-10",
  autoRemove: true,
});

function StepSignature({ recId, style, mode = "static", record, tableId }) {
  const { reload } = useTable();
  const id = mode != "static" ? recId : recId.value;
  const { updateRecord, findRecord } = useStore();
  const _layoutStaffSupply = layoutStaffSupply();
  const _record = findRecord(_layoutStaffSupply.model, id);

  function addSignature(data) {
    const { name, image } = data;
    const toActive = {
      ..._record?.active,
      [name]: image,
    };
    const toStore = { files: {}, ..._record?.store };
    toStore.files[name] = image;

    if (mode === "static") {
      updateRecord(toActive, toStore, _layoutStaffSupply.model, id);
    } else {
      toStore.id = id;
      updateSignature(toStore);
    }
  }

  async function updateSignature(data) {
    const res = await proxy.saveQuery({
      model: _layoutStaffSupply.model,
      storeRec: data,
      fieldsNames: ["id", "number"],
    });

    if (res) {
      const { data: resSig } = await proxy.browse(
        "staff_supply.request",
        [id],
        ["recipient_signature", "delivery_signature"],
      );
      const recipientSig = data.files?.recipient_signature;
      if (recipientSig) {
        console.log(
          "✅ Firma del receptor completada, ejecutando método 'done'...",
        );
        await proxy.buttonMethod({
          model: "staff_supply.request",
          method: "done",
          ids: [id],
        });

        reload(tableId);
        alertMsg.value = {
          ...alertMsg.value,
          show: true,
          text: "Firmas actualizadas",
        };
      } else {
        console.log("⚠️ Aún no se ha agregado la firma del receptor.");
      }
    }
  }

  return (
    <Fragment>
      <div className={style ?? DEFAULT_STYLE}>
        <p className="text-md text-gray-500 text-center">
          <FM id="staff_supply.label.signature" />
        </p>
        <div className="flex space-x-4 justify-center mt-10">
          <SignatureCell
            label="staff.supply.delivery_signature"
            name="delivery_signature"
            onSave={addSignature}
            model={_layoutStaffSupply.model}
            value={record?.delivery_signature}
          />
          <SignatureCell
            label="staff.supply.recipient_signature"
            name="recipient_signature"
            onSave={addSignature}
            model={_layoutStaffSupply.model}
            value={record?.recipient_signature}
          />
        </div>
        {mode == "modal" && <Alert {...alertMsg.value} />}
      </div>
    </Fragment>
  );
}

export default StepSignature;
